import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledBoxCTAButton, StyledBoxCTAIconWrapper, StyledBoxCTALink, StyledBoxCTAText } from './BoxCTA.styles';
import { texts } from './BoxCTA.texts';
const isCTAPropsWithChildren = (props)=>Boolean(props?.children);
export const BoxCTA = (props)=>{
    const { ariaLabel, as, className, 'data-dd-action-name': ddAction, 'data-testid': testId, icon, isSlim, isWide, tabIndex, variant = 'primary' } = props;
    const children = isCTAPropsWithChildren(props) ? props.children : undefined;
    if (as === 'a') {
        const { href, isDownload = false, onClick, target } = props;
        return /*#__PURE__*/ _jsxs(StyledBoxCTALink, {
            $isSlim: isSlim,
            $isWide: isWide,
            $variant: variant,
            "aria-label": ariaLabel,
            className: className,
            "data-dd-action-name": ddAction,
            "data-testid": testId,
            download: isDownload,
            href: href,
            onClick: onClick,
            tabIndex: tabIndex,
            target: target,
            children: [
                icon && /*#__PURE__*/ _jsx(StyledBoxCTAIconWrapper, {
                    children: icon
                }),
                children && /*#__PURE__*/ _jsx(StyledBoxCTAText, {
                    children: children
                })
            ]
        });
    }
    const { formId, isDisabled, isLoading, onClick, type } = props;
    return /*#__PURE__*/ _jsxs(StyledBoxCTAButton, {
        $isSlim: isSlim,
        $isWide: isWide,
        $variant: variant,
        "aria-label": ariaLabel,
        as: "button",
        className: className,
        "data-dd-action-name": ddAction,
        "data-testid": testId,
        disabled: isDisabled || isLoading,
        form: formId,
        onClick: onClick,
        tabIndex: tabIndex,
        type: type,
        children: [
            icon && /*#__PURE__*/ _jsx(StyledBoxCTAIconWrapper, {
                children: icon
            }),
            children && /*#__PURE__*/ _jsx(StyledBoxCTAText, {
                $isLoading: isLoading,
                children: isLoading ? texts.label.loading : children
            })
        ]
    });
};

//# sourceMappingURL=BoxCTA.js.map